export default __webpack_public_path__ + "static/media/10.9e126b26.jpg";